/**
 * Created by wangjianwen on 2017/10/16.
 */
import Lockr from 'lockr'
export default {
    getHeaderState(states){
        return states.headerState;
    },
    getToken(states){
        return states.token;
    },
    getJwtToken(states){
        return states.jwtToken;
    },
    getUserType(states){
        return states.userType;
    },
    getFooterInfo(states){
        return states.footerInfo;
    },
    getCurrentUser(states){
        return states.currentUser
    },
    getCertType(states){
        return states.certType
    },
    getPageInfo(states){
        return states.pageInfo
    },
    getProjectToken(states){
        return states.projectToken
    },
};